import { Metric, NativeCurrencyMetric } from "@blisspointmedia/bpm-types/dist/CrossChannel";
import { GlossaryItem } from "../Components/GlossaryModal/GlossaryModal";

export const DELIVERY_METRICS = [Metric.CPM, Metric.IMPRESSIONS, Metric.SPEND];
export const PERFORMANCE_METRICS = [
  Metric.CLICKS,
  Metric.CLICKS_CONVERSION_RATE,
  Metric.IMPS_CONVERSION_RATE,
  Metric.CPC,
  Metric.CPX,
  Metric.CTR,
  Metric.REVENUE,
  Metric.ROAS,
  Metric.VOLUME,
];

export const METRIC_TO_PRETTY_NAME = {
  [Metric.CLICKS]: "Clicks",
  [Metric.CLICKS_CONVERSION_RATE]: "Clicks Conversion Rate",
  [Metric.IMPS_CONVERSION_RATE]: "Imps Conversion Rate",
  [Metric.CPC]: "CPC",
  [Metric.CPM]: "CPM",
  [Metric.CPX]: "CPX",
  [Metric.CPX_DIRECT]: "CPX, Direct",
  [Metric.CPX_DIRECT_INCREMENTAL]: "CPX, Direct Incremental",
  [Metric.CPX_DIRECT_RAW]: "CPX, Direct Raw",
  [Metric.CPX_FRACTIONAL]: "CPX, Frational",
  [Metric.CPX_FULL_FUNNEL]: "CPX, Full Funnel",
  [Metric.CPX_FULL_FUNNEL_RAW]: "CPX, Full Funnel Raw",
  [Metric.CPX_HALO]: "CPX, Halo",
  [Metric.CPX_INCREMENTAL]: "CPX, Incremental",
  [Metric.CTR]: "CTR",
  [Metric.IMPRESSIONS]: "Impressions",
  [Metric.REVENUE]: "KPI Revenue",
  [Metric.REVENUE_DIRECT]: "KPI Revenue, Direct",
  [Metric.REVENUE_DIRECT_INCREMENTAL]: "KPI Revenue, Direct Incremental",
  [Metric.REVENUE_DIRECT_RAW]: "KPI Revenue, Direct Raw",
  [Metric.REVENUE_FRACTIONAL]: "KPI Revenue, Frational",
  [Metric.REVENUE_FULL_FUNNEL]: "KPI Revenue, Full Funnel",
  [Metric.REVENUE_FULL_FUNNEL_RAW]: "KPI Revenue, Full Funnel Raw",
  [Metric.REVENUE_HALO]: "KPI Revenue, Halo",
  [Metric.REVENUE_INCREMENTAL]: "KPI Revenue, Incremental",
  [Metric.ROAS]: "ROAS",
  [Metric.ROAS_DIRECT]: "ROAS, Direct",
  [Metric.ROAS_DIRECT_INCREMENTAL]: "ROAS, Direct Incremental",
  [Metric.ROAS_DIRECT_RAW]: "ROAS, Direct Raw",
  [Metric.ROAS_FRACTIONAL]: "ROAS, Frational",
  [Metric.ROAS_FULL_FUNNEL]: "ROAS, Full Funnel",
  [Metric.ROAS_FULL_FUNNEL_RAW]: "ROAS, Full Funnel Raw",
  [Metric.ROAS_HALO]: "ROAS, Halo",
  [Metric.ROAS_INCREMENTAL]: "ROAS, Incremental",
  [Metric.SPEND]: "Spend",
  [Metric.VOLUME]: "KPI Volume",
  [Metric.VOLUME_DIRECT]: "KPI Volume, Direct",
  [Metric.VOLUME_DIRECT_INCREMENTAL]: "KPI Volume, Direct Incremental",
  [Metric.VOLUME_DIRECT_RAW]: "KPI Volume, Direct Raw",
  [Metric.VOLUME_FRACTIONAL]: "KPI Volume, Frational",
  [Metric.VOLUME_FULL_FUNNEL]: "KPI Volume, Full Funnel",
  [Metric.VOLUME_FULL_FUNNEL_RAW]: "KPI Volume, Full Funnel Raw",
  [Metric.VOLUME_HALO]: "KPI Volume, Halo",
  [Metric.VOLUME_INCREMENTAL]: "KPI Volume, Incremental",
  [NativeCurrencyMetric.SPEND_NATIVE]: "Spend Raw",
  [NativeCurrencyMetric.REVENUE_NATIVE]: "KPI Revenue Raw",
  [NativeCurrencyMetric.CPC_NATIVE]: "CPC Raw",
  [NativeCurrencyMetric.CPM_NATIVE]: "CPM Raw",
  [NativeCurrencyMetric.CPX_NATIVE]: "CPX Raw",
  ctrEmail: "CTR",
  eCpm: "eCPM",
  youtubeCpm: "CPM",
} as const;

export const METRIC_OPTIONS = [
  { label: METRIC_TO_PRETTY_NAME[Metric.CLICKS], value: Metric.CLICKS },
  {
    label: METRIC_TO_PRETTY_NAME[Metric.CLICKS_CONVERSION_RATE],
    value: Metric.CLICKS_CONVERSION_RATE,
  },
  { label: METRIC_TO_PRETTY_NAME[Metric.IMPS_CONVERSION_RATE], value: Metric.IMPS_CONVERSION_RATE },
  { label: METRIC_TO_PRETTY_NAME[Metric.CPC], value: Metric.CPC },
  { label: METRIC_TO_PRETTY_NAME[Metric.CPM], value: Metric.CPM },
  { label: METRIC_TO_PRETTY_NAME[Metric.CPX], value: Metric.CPX },
  { label: METRIC_TO_PRETTY_NAME[Metric.CTR], value: Metric.CTR },
  { label: METRIC_TO_PRETTY_NAME[Metric.IMPRESSIONS], value: Metric.IMPRESSIONS },
  { label: METRIC_TO_PRETTY_NAME[Metric.REVENUE], value: Metric.REVENUE },
  { label: METRIC_TO_PRETTY_NAME[Metric.ROAS], value: Metric.ROAS },
  { label: METRIC_TO_PRETTY_NAME[Metric.SPEND], value: Metric.SPEND },
  { label: METRIC_TO_PRETTY_NAME[Metric.VOLUME], value: Metric.VOLUME },
];

export const DELIVERY_METRIC_OPTIONS = METRIC_OPTIONS.filter(metric =>
  DELIVERY_METRICS.includes(metric.value)
);
export const PERFORMANCE_METRIC_OPTIONS = METRIC_OPTIONS.filter(metric =>
  PERFORMANCE_METRICS.includes(metric.value)
);

export const MEDIA_TYPE_TO_PRETTY_NAME = {
  audio: "Audio",
  display: "Display",
  streaming: "Streaming",
  tv: "Linear TV",
  social: "Social",
  search: "Search",
} as const;

export const GRAY_BAR_COLOR = "#E6E6E6";
export const GRAY_TEXT_COLOR = "#ADADAD";

export const DESCRIPTIVE_METRICS = [Metric.CPM, Metric.CLICKS, Metric.IMPRESSIONS, Metric.SPEND];

export const GLOSSARY: GlossaryItem[] = [
  {
    term: "Channel",
    definition: "This is a type of marketing effort (e.g. Paid Social).",
  },
  {
    term: "Platform",
    definition: "This is the system through which the ad impression is delivered (e.g. Meta).",
  },
  {
    term: "Surface",
    definition:
      "This is the end point where the ad is delivered to its audience (e.g. Facebook or Instagram). Note: surface isn't always applicable.",
  },
  {
    term: "Clicks",
    definition: "The number of individuals who click on the ad(s).",
  },
  {
    term: "Spend",
    definition: "The total dollars invested.	The number of dollars invested.",
  },
  {
    term: "Impressions",
    definition: "The number of times the ad(s) are delivered.",
  },
  {
    term: "KPI Volume",
    definition:
      "The number of outcome events generated (for the KPI selected in the dropdown at the top of the page).",
  },
  {
    term: "KPI Revenue",
    definition:
      "The number of dollars generated in return (for the KPI selected in the dropdown at the top of the page).",
  },
  {
    term: "CPM",
    definition: "Cost per Thousand Impresisons = (spend x 1,000) / impressions",
  },
  {
    term: "ROAS",
    definition: "Return on Ad Spend = revenue / spend",
  },
  {
    term: "CPX",
    definition:
      "Cost per X = total spend / KPI volume (X is a placeholder letter for the KPI selected in the dropdown at the top of the page)",
  },
  {
    term: "CPC",
    definition: "Cost per Click = spend / clicks",
  },
  {
    term: "CTR",
    definition: "The percentage of impressions that result in a click.",
  },
  {
    term: "Conversion Rate",
    definition: "The percentage of impressions that result in a conversion.",
  },
];

export const DELIVERY_CURRENCY_CODE = "delivery_currency_code";
export const PERFORMANCE_CURRENCY_CODE = "performance_currency_code";
